import { useState, useCallback } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./NDVIDateModal.css";
import { useT } from "../../i18n";

const toDateKey = (date) => date.toLocaleDateString("en-CA");

const isSameMonth = (a, b) =>
  a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();

export function NDVIDateModal({
  isOpen,
  onClose,
  onApply,
  onChange,
  value,
  missionDates = new Set(),
}) {
  const [viewDate, setViewDate] = useState(null);
  const t = useT();
  if (!isOpen) return null;

  const hasMissionDates = missionDates.size > 0;
  const currentView = viewDate ?? value ?? new Date();
  const showSelected = value && isSameMonth(value, currentView);

  return (
    <div className="ndvi-date-overlay" onClick={onClose}>
      <div
        className="ndvi-date-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t("map.dateModal.title")}
      >
        <div className="ndvi-date-header">
          <h3>{t("map.dateModal.title")}</h3>
          <button type="button" className="ndvi-date-close" onClick={onClose}>
            X
          </button>
        </div>
        <div className="ndvi-date-body">
          <DatePicker
            selected={showSelected ? value : null}
            onChange={(date) => {
              setViewDate(date);
              onChange(date);
            }}
            onMonthChange={(date) => setViewDate(date)}
            openToDate={currentView}
            inline
            calendarClassName="ndvi-date-calendar"
            maxDate={new Date()}
            filterDate={
              hasMissionDates
                ? (date) => missionDates.has(toDateKey(date))
                : undefined
            }
            dayClassName={(date) =>
              hasMissionDates && missionDates.has(toDateKey(date))
                ? "ndvi-date--has-mission"
                : null
            }
          />
        </div>
        <div className="ndvi-date-footer">
          <button type="button" className="ndvi-date-cancel" onClick={onClose}>
            {t("map.dateModal.cancel")}
          </button>
          <button
            type="button"
            className="ndvi-date-apply"
            onClick={onApply}
          >
            {t("map.dateModal.apply")}
          </button>
        </div>
      </div>
    </div>
  );
}

